import { Flex, Radio, Text } from '@shared/components';
import { useController } from 'react-hook-form';

interface FormBooleanRadioProps {
  name: string;
  label?: string;
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
}

export default function FormBooleanRadio(props: FormBooleanRadioProps) {
  const { name, required, disabled } = props;
  const {
    field: { value, onChange, ref },
    fieldState: { error },
  } = useController({
    name,
    rules: required
      ? {
          validate: (v) => (typeof v === 'boolean' ? true : 'กรุณาเลือก'),
        }
      : undefined,
  });

  const handleChange = (newValue: boolean) => {
    onChange(newValue);
  };

  return (
    <Flex
      ref={ref as React.Ref<HTMLDivElement>}
      sx={(theme) => ({
        flexDirection: 'column',
        alignItems: 'start',
        gap: theme.spacing(1),
      })}
    >
      <Flex
        sx={(theme) => ({
          gap: theme.spacing(2),
          alignItems: 'start',
        })}
      >
        <Radio
          value='yes'
          checked={value === true}
          onChange={() => handleChange(true)}
          label='มี'
          disabled={disabled}
        />
        <Radio
          value='no'
          checked={value === false}
          onChange={() => handleChange(false)}
          label='ไม่มี'
          disabled={disabled}
        />
      </Flex>
      {error?.message ? (
        <Text variant='body2' color='error'>
          {error.message}
        </Text>
      ) : null}
      {required ? (
        <Text variant='body2' color='error.main' sx={{ visibility: 'hidden' }}>
          *
        </Text>
      ) : null}
    </Flex>
  );
}
